import React, { useState } from 'react';
import parts from '../moduleCard/moduleParts.module.css';
import ListItem from './list/ListItem';
import ViewDocumentPopup from '../../../../popup/ViewDocumentPopup/ViewDocumentPopup';
import PrescriptionPopup from '../../../../popup/PrescriptionPopup/PrescriptionPopup';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ModuleCard from '../moduleCard/ModuleCard';
import ModuleEmptyState from '../moduleCard/ModuleEmptyState';
import { prescriptionTitle } from '../../modules/prescription/prescriptionModel';

/**
 * Documentos emitidos: atestados e demais documentos, mais as receitas do
 * paciente. A receita abre no editor, com PDF e WhatsApp.
 *
 * `prescriptions`: receitas do paciente; `prescriptionProps`: contexto do
 * editor (patientId, patientName, appointmentId, appointmentDate,
 * professionalId, templates, onUpdated, readOnly).
 */
const Documents = ({ title = 'Documentos emitidos', patientData, list, prescriptions = [], prescriptionProps = {}, collapsible = false }) => {
    const [currentDocumentData, setCurrentDocumentData] = useState(null);
    const [currentPrescription, setCurrentPrescription] = useState(null);

    const items = [
        ...list.map((item) => ({ key: `d${item.id}`, date: item.date, title: item.title, open: () => setCurrentDocumentData(item) })),
        ...prescriptions.map((item) => ({ key: `p${item.id}`, date: item.issuedAt, title: prescriptionTitle(item), open: () => setCurrentPrescription(item) })),
    ].sort((a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0));

    const selectItemHandler = (key) => {
        const item = items.find((entry) => entry.key === key);
        if (item) item.open();
    }

    function prescriptionHideHandler(needsReload) {
        setCurrentPrescription(null);
        if (needsReload && prescriptionProps.onUpdated) prescriptionProps.onUpdated();
    }

    return (
        <>
            <ModuleCard
                accent="blue"
                title={title}
                icon={<DescriptionOutlinedIcon />}
                description={`Total: ${items.length} documento(s)`}
                collapsible={collapsible}
            >
                {items.length == 0 ? (
                    <ModuleEmptyState icon={<DescriptionOutlinedIcon />} text="Não existem documentos emitidos." />
                ) : (
                    <div className={parts.scrollList}>
                        {items.map((item) => (
                            <ListItem
                                key={item.key}
                                id={item.key}
                                date={item.date}
                                title={item.title}
                                onSelect={selectItemHandler}
                            />
                        ))}
                    </div>
                )}
            </ModuleCard>

            {currentDocumentData &&
                <ViewDocumentPopup
                    data={currentDocumentData}
                    patientData={patientData}
                    OnHide={() => setCurrentDocumentData(null)}
                />
            }

            {currentPrescription && (
                <PrescriptionPopup
                    {...prescriptionProps}
                    prescription={currentPrescription}
                    OnHide={prescriptionHideHandler}
                />
            )}
        </>
    );
};

export default Documents;
